import ab from './atlassian-breaks';
import hss from './hands-so-sleight';
import wh from './westport-hymn';
import motc from './men-of-the-cloth';
import rpt from './real-page-turner';
import ls from './less-superstitious';
import st from './sweet-toothe';
import nj from './nunca-jamas';
import pys from './pick-your-socket';
import xw from './xwhy';
import me from './my-education';
import tlp from './the-latent-psychic';
import ww from './westheimer-waltz';
import ff from './force-fields';
import nox from './equinoxical';
import sv from './sal-valotile';
import te from './tumult-etc';
import lb from './lazy-bones';
import lux from './equiluxical';
import lwfo from './long-way-from-olympus';
import cm from './color-math';
import sj from './saint-juan';
import labo from './la-boda';
import mi from './mare';
import cc from './cofc';
import proto from './proto';
import of from './odd-fauna';
import mevg from './eddy';
import pe from './potential-energy';

const lyrics = {
    sr: {
        pys,
        ff,
        wh,
        pe,
    },
    cs: {
        cm,
        sj,
        labo,
        mi,
        cc,
        proto,
        of,
        mevg,
    },
    equi: {
        nox,
        sv,
        te,
        lb,
        lux,
        lwfo,
    },
	r: {
    ww,
    gd: '"...to the East, we see an extremely bright object, I believe it\'s too bright to be a planet, it\'s North of Orion, about..." - NASA Gemini Expedition (1966)',
    r: 'You settled on you...',
    ff
  },
  ab: {
		ab,
		hss,
		wh,
		motc
	},
	vv: {
    rpt,
    ls,
    st,
    nj,
    pys,
    xw,
    me,
    tlp
	}
}

export default lyrics;